import React, { useState } from "react"
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"

const SimpleFilterList = ({ selectedAcuities, setSelectedAcuities, setSearchTerm }) => {
	const acuityOptions = [1, 2, 3, 4, 5]
	const [isExpanded, setIsExpanded] = useState(false)

	return (
		<>
			<div className="relative">
				<input
					type="text"
					placeholder="Search for patients..."
					className="border border-gray-300 rounded-md p-2 pl-10 mb-4 w-full"
					onChange={e => {
						setSearchTerm(e.target.value)
					}}
				/>
				<MagnifyingGlassIcon className="h-5 w-5 text-gray-400 absolute left-3 top-2.5" />
			</div>
			<div className="mb-4">
				<div className="mb-4">
					<div className="relative">
						<button
							className="flex items-center space-x-2 text-gray-700 hover:bg-gray-100 p-2 rounded-md w-full"
							onClick={() => setIsExpanded(!isExpanded)}
						>
							<svg
								className={`h-4 w-4 transform transition-transform ${
									isExpanded ? "rotate-90" : ""
								}`}
								viewBox="0 0 20 20"
								fill="currentColor"
							>
								<path
									fillRule="evenodd"
									d="M7.293 4.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L10.586 9 7.293 5.707a1 1 0 010-1.414z"
									clipRule="evenodd"
								/>
							</svg>
							<span>Filter by Acuity</span>
						</button>
						{isExpanded && (
							<div className="mt-2 flex space-x-2">
								{acuityOptions.map(option => (
									<div
										key={option}
										className="py-2 w-full text-left cursor-pointer"
									>
										<label className="flex items-center space-x-2">
											<input
												type="checkbox"
												className="form-checkbox h-4 w-4 text-customBlue rounded border-gray-300 focus:ring-0"
												checked={selectedAcuities.includes(option)}
												onChange={() => {
													setSelectedAcuities(prev =>
														prev.includes(option)
															? prev.filter(ac => ac !== option)
															: [...prev, option]
													)
												}}
											/>
											<span className="text-gray-800">{option}</span>
										</label>
									</div>
								))}
							</div>
						)}
					</div>
				</div>
			</div>
		</>
	)
}

export default SimpleFilterList
